<template>
  <div class="content self-content">
    <headNav
      :color="color"
      :title="info.productName"
      :back="true"
      :white="true"
    />
    <div id="integral_details">
      <!-- 廣告圖 -->
      <div class="cell-banner">
        <van-image :src="info.imgUrl">
          <template v-slot:error>
            <img
              style="width:100%;"
              src="../../assets/icon/small_default.png"
            />
          </template>
        </van-image>
      </div>
      <!-- 標題 -->
      <div class="cell-title">
        <div style="width:100%;">
          <p
            class="cell-p ell1"
            v-text="info.productName"
          ></p>
          <div class="cell-price">
            <span
              v-text="info.points"
              class="self_color"
            ></span>
            <span>{{ window_c['points'] }}</span>

            <span class="surplus">
              {{ window_c['Surplus'] }}
              <i class="self_color">{{ info.stock }}</i>
              {{ window_c['Portion'] }}
            </span>
          </div>
        </div>
      </div>
      <!-- 描述 -->
      <div class="cell-desc">
        <div v-html="info.productDesc"></div>
      </div>
      <div class="cell-desc">
        <div v-html="info.productRules"></div>
      </div>
    </div>
    <!-- 兌換 -->
    <div
      v-if="info.saleType == '0' && info.statusVal == '4'"
      class="cell-footer"
    >
      <p>{{ window_c['Out of stoce'] }}</p>
      <p>{{ window_c['Redeem now'] }}</p>
    </div>
    <div
      v-if="info.saleType == '0' && info.statusVal == '4' && this.total >= info.points"
      class="cell-footer"
    >
      <p>{{ window_c['Out of stoce'] }}</p>
      <p>{{ window_c['Redeem now'] }}</p>
    </div>
    <div
      v-if="info.saleType == '0' && info.statusVal == '3' && this.total >= info.points"
      class="cell-footer"
    >
      <p></p>
      <p
        @click="info.stock > 0 && (show = true)"
        :class="{ canClick: info.stock > 0 }"
      >{{ window_c['Redeem now'] }}</p>
    </div>
    <div
      v-if="info.saleType == '0' && info.statusVal == '3' && this.total < info.points"
      class="cell-footer"
    >
      <p></p>
      <p>{{ window_c['Insufficient points'] }}</p>
    </div>
    <div
      v-if="info.saleType == '1' && info.statusVal == '1'"
      class="cell-footer"
    >
      <p>{{ info.sacleBeginTime }} {{ window_c['Open up'] }}</p>
      <p>{{ window_c['Redeem now'] }}</p>
    </div>
    <div
      v-else-if="info.saleType == '1' && info.statusVal == '2'"
      class="cell-footer"
    >
      <p>{{ window_c['Panic buying has ended'] }}</p>
      <!-- <p @click="show = true">{{window_c['Redeem now']}}</p> -->
    </div>
    <!-- 用戶積分 >= 商品積分 且 datediff > 1天(3600s) -->
    <div
      v-else-if="info.saleType == '1' && (info.statusVal == '3' && this.total >= info.points) && info.datediff > 86400"
      class="cell-footer"
    >
      <!-- <p>{{window_c['Panic buying has ended']}}</p> -->
      <p>{{ info.expires }}</p>
      <p
        @click="info.stock > 0 && (show = true)"
        :class="{ canClick: info.stock > 0 }"
      >{{ window_c['Redeem now'] }}</p>
    </div>
    <!-- 用戶積分 >= 商品積分 且 datediff < 1天(3600s) -->
    <div
      v-else-if="info.saleType == '1' && (info.statusVal == '3' && this.total >= info.points) && info.datediff < 86400"
      class="cell-footer"
    >
      <p ref="countTime">{{ window_c['Remaining'] }} {{ countDownTime }} {{ window_c['End'] }}</p>
      <p
        :class="{ canClick: addBtnFlag && info.stock > 0 }"
        @click="addBtnFlag && info.stock > 0 && (show = true)"
        v-if="info.saleType == '1' && (info.statusVal == '3' && this.total >= info.points) && info.datediff < 86400"
      >
        {{ window_c['Redeem now'] }}
      </p>
      <p v-else>{{ window_c['Redeem now'] }}</p>
    </div>
    <!-- 用戶積分 < 商品積分-->
    <div
      v-else-if="info.saleType == '1' && (info.statusVal == '3' && this.total < info.points)"
      class="cell-footer"
    >
      <p>{{ window_c['Insufficient points'] }}</p>
      <p>{{ window_c['Redeem now'] }}</p>
    </div>
    <div
      v-else-if="info.saleType == '1' && info.statusVal == '4'"
      class="cell-footer"
    >
      <p>{{ window_c['Panic buying has ended'] }}</p>
      <!-- <p @click="show = true">{{window_c['Out of stoce']}}</p> -->
      <p>{{ window_c['Out of stoce'] }}</p>
    </div>

    <!-- <p v-if="item.saleType == '1' && item.statusVal == '1'" class="cell-status">{{ item.saleBeginTime }}{{window_c['Open up']}}</p>
		<p v-else-if="item.saleType == '1' && item.statusVal == '2'" class="cell-status2"><span>{{window_c['Panic buying has ended']}}</span></p>
		<p v-else-if="item.saleType == '1' && item.statusVal == '3'" class="cell-status">立即搶購</p>
		<p v-else-if="item.saleType == '1' && item.statusVal == '4'" class="cell-status">{{window_c['Out of stoce']}}</p> -->

    <!-- 彈窗 -->
    <!-- <van-dialog @confirm="exchanges" v-model="show" title="請選擇你要兌換的數量" show-cancel-button>
			<div class="cell-stepper"><van-stepper v-model="count" integer /></div>
		</van-dialog> -->
    <!-- 彈窗 -->
    <van-dialog
      @cancel="exchanges"
      v-model="show"
      :title="`${window_c['Warm reminder']}`"
      :confirmButtonText="`${window_c['cancel']}`"
      :cancelButtonText="`${window_c['confirm']}`"
      show-cancel-button
    >
      <!-- <div class="cell-stepper"><van-stepper v-model="count" integer /></div> -->
      <div class="warm-prompt self_color">{{ window_c['Are you sure'] }}{{ info.points }}{{ window_c['points'] }}{{ window_c['exchange'] }}？</div>
    </van-dialog>
  </div>
</template>
<script>
import headNav from '@/components/headNav';
import { getProductInfoById, exchange } from '@/js/api';
import util from '@/js/util.js';
import lang_ from '@/js/locales';
export default {
  data () {
    return {
      info: {},
      count: 1,
      show: false,
      total: sessionStorage.getItem('consumePoints'), //用戶積分
      countDownTime: '', //倒計時
      timeId: null, //存儲計時器
      addBtnFlag: true,
      window_c: {
        'There are 1': '優惠券',
        coupons: '張',
        'There are 2': '積分',
        points: '分',
        Surplus: '尚餘',
        'Out of stoce': '已售罄',
        'Redeem now': '立即兌換',
        'Insufficient points': '積分不足',
        'Open up': '開搶',
        'Panic buying has ended': '搶購已結束',
        Remaining: '剩餘',
        End: '結束',
        'Are you sure': '是否確認以',
        exchange: '兌換',
        'Warm reminder': '溫馨提示',
        cancel: '取消',
        confirm: '確認',
        Hour: '時',
        Minute: '分',
        Second: '秒'
      },
      color: ""
    };
  },
  created () {
    this.init_lang();
    util.selfSetIcon(); // 設置logo
    util.getBrand(this, () => {
      this.getProductInfo();
      this.color = this.themeColor;
    })
  },
  mounted () { },
  methods: {
    //
    getProductInfo () {
      var self = this;
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加載中....'
      });
      let id = util.getQueryParams(this.$route.params)[1];
      getProductInfoById({ productId: id }).then(res => {
        if (res.code == '1') {
          self.$toast.clear();
          this.info = res.data;
          if (this.info.saleType == '1' && (this.info.statusVal == '3' && this.total >= this.info.points) && this.info.datediff < 86400) {
            console.log('撿來了');
            let newDatediff = this.info.datediff;
            var fn = () => {
              if (newDatediff == 0) {
                clearInterval(this.timeId);
                this.$refs.countTime.innerHTML = ' ';
                this.addBtnFlag = false;
              }
              newDatediff--;
              let hours = Math.floor((newDatediff / (60 * 60)) % 24);
              let min = Math.floor((newDatediff / 60) % 60);
              let seconds = Math.floor(newDatediff % 60);
              //小於10 前面補0
              hours = hours < 10 ? '0' + hours : hours;
              min = min < 10 ? '0' + min : min;
              seconds = seconds < 10 ? '0' + seconds : seconds;
              this.countDownTime = `${hours}${window_c['Hour']}${min}${window_c['Minute']}${seconds}${window_c['Second']}`;
            };
            fn();
            this.timeId = setInterval(() => {
              fn();
            }, 1000);
          }
        }
      });
    },
    // 兌換
    exchanges () {
      var self = this;
      const toast = this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加載中....'
      });
      let id = util.getQueryParams(this.$route.params)[1];
      let userInfoStr = util.userInfo.get(this);
      var data = {
        memberId: JSON.parse(userInfoStr).memberId,
        count: this.count,
        productId: id
      };
      exchange(data).then(res => {
        console.log(res);
        if (res.code == '1') {
          self.$toast.clear();
          this.$toast(res.errorMsg);
          this.show = false;
          //更改用戶積分
          sessionStorage.setItem('consumePoints', this.total - this.info.points);
          //商品剩餘數量-1
          this.$set(this.info, 'stock', this.info.stock - 1);
        }
      });
    },
    errorImg (img) {
      return util.errorImg(img);
    },
    init_lang () {
      var window_c = this.window_c;
      window_c['There are 1'] = lang_.t('There are 1');
      window_c['coupons'] = lang_.t('coupons');
      window_c['There are 2'] = lang_.t('There are 2');
      window_c['points'] = lang_.t('points');

      (window_c['Surplus'] = lang_.t('Surplus')),
        (window_c['Out of stoce'] = lang_.t('Out of stoce')),
        (window_c['Redeem now'] = lang_.t('Redeem now')),
        (window_c['Insufficient points'] = lang_.t('Insufficient points')),
        (window_c['Open up'] = lang_.t('Open up')),
        (window_c['Panic buying has ended'] = lang_.t('Panic buying has ended')),
        (window_c['Remaining'] = lang_.t('Remaining')),
        (window_c['End'] = lang_.t('End')),
        (window_c['Are you sure'] = lang_.t('Are you sure')),
        (window_c['exchange'] = lang_.t('exchange')),
        (window_c['Warm reminder'] = lang_.t('Warm reminder'));
      window_c['cancel'] = lang_.t('cancel');
      window_c['confirm'] = lang_.t('confirm');
      window_c['Hour'] = lang_.t('Hour');
      window_c['Minute'] = lang_.t('Minute');
      window_c['Second'] = lang_.t('Second');
    }
  },
  components: {
    headNav
  }
};
</script>
<style scoped>
.self-content {
  width: 100%;
  height: 100%;
  padding: 46px 0 0 0 !important;
}
#integral_details {
  padding-left: 10px;
  padding-right: 10px;
  background-color: #fff;
  margin-bottom: 49px;
  height: calc(100% - 49px);
  padding-bottom: 10px;
  overflow-x: hidden;
  overflow-y: auto;
}
.cell-banner {
  border: 1px solid #eee;
  background-color: #fff;
  box-shadow: 0 0 10px #dddddd;
  width: 98%;
  margin: 10px auto;
}
.cell-title {
  margin: 20px 0;
  display: flex;
}
.cell-p {
  font-size: 16px;
  color: #000;
  margin-bottom: 10px;
}
.cell-price {
  /* display: flex; */
  align-items: center;
}
.cell-price span:first-child,
.surplus i {
  font-size: 15px;
  font-weight: bold;
  margin-right: 10px;
  color: #23bfa7;
}
.cell-price span:nth-child(2) {
  font-size: 18px;
}
/* .cell-price span:last-child {
	font-size: 18px;
} */
.cell-desc {
}
.cell-desc div::-webkit-scrollbar {
  display: none;
}
.cell-desc div {
  width: 100%;
  max-height: 900px;
  border: none;
  overflow-y: auto;
}

.cell-footer {
  position: fixed;
  height: 49px;
  width: 100%;
  bottom: 0;
  background-color: #4c4c4c;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  color: #fff;
  font-size: 16px;
}
.cell-footer p:last-child {
  height: 40px;
  padding: 0 20px;
  background-color: #7f7f7f;
  text-align: center;
  line-height: 40px;
  border-radius: 4px;
}
cell-p .cell-footer p:last-child:active {
  opacity: 0.9;
}
.cell-stepper {
  text-align: center;
  margin: 20px 0;
}

.ell2 {
  font-size: 28px;
  color: #000;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  margin-left: auto;
}

.ell2 span {
  color: #23bfa7;
  padding: 5px;
}

.surplus {
  float: right;
  font-size: 14px;
}
.surplus i {
  font-style: normal;
  color: #23bfa7;
}
.canClick {
  background: #23bfa7 !important;
}
.warm-prompt {
  margin: 10px 0;
  text-align: center;
  color: #23bfa7;
}
.ell1 {
  white-space: pre-wrap;
}
.cell-banner .van-image {
  vertical-align: middle;
}
</style>
<style lang="less" scoped>
/deep/ .van-dialog .van-button {
  border: 0.5px solid;
  border-radius: 0;
}
/deep/ .van-image {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/vipCard/integral_details.vue